window.CallCenter = {
  Bus: {},
  Views: {
    Mixins: {},
  },
  Collections: {},
  Models: {},
};
